module.exports = __webpack_public_path__ + "img/soccer.0b5670b7.svg";